<span class="context-menu-container">
  <p-contextMenu #tableContextMn [model]="contextMenuConfig" [hidden]="disableContextMenu"
                 appendTo="body"
                 (onShow)="contextMenuShow($event)"></p-contextMenu>
</span>

<span class="flexTableViewPort"
      (mouseenter)="focuseIn(-1, true)"
      (mouseleave)="focusOut(true)">
  <p-table #ccTable
           [columns]="tableConfig" [value]="records"
           [scrollable]="true" [scrollHeight]="scrollHeightNumber<0?scrollHeightString:( scrollHeightNumber+'px')"
           [virtualScroll]="true" [virtualScrollItemSize]="20"
           [lazy]="true" (onLazyLoad)="onLazyLoadDebounced($event)" [lazyLoadOnInit]="lazyLoadOnInit"
           [virtualScrollDelay]="0"
           styleClass="crystal-table p-datatable-sm p-datatable-gridlines"
           [loading]="loading"
           (mousedown)="mouseDown=true;" (mouseup)="mouseDown=false;"
           [sortField]="defaultSortField" [sortOrder]="defaultSortOrder" [defaultSortOrder]="defaultSortOrder"
           [contextMenu]="disableContextMenu?undefined:tableContextMn" [(contextMenuSelection)]="selectedRecord"
           [resizableColumns]="true" columnResizeMode="fit"
           [reorderableColumns]="true"
           (onColReorder)="colOrderChanged($event)"
           (focusin)="focuseIn(-1)" (focusout)="focusOut()"
           (mouseenter)="focuseIn(-1, true)" (mouseleave)="focusOut(true)"
           (onFilter)="onFilterChange()" (onSort)="onSortChange()">
<!--           [customSort]="true"-->
    <!--           (sortFunction)="onSortChange($event)"-->
    <ng-template pTemplate="caption">
      <span class="caption-left">
        <span class="m-0-5-0-0"></span>
        <ng-content select="[caption-left-left]"></ng-content>
        <span
          class="table-toolbar-title">{{ totalRecords + ' ' + ((headerTitle ? headerTitle : ('page.' + this.transPartKey + '.header_count')) | translate) }}</span>
        <ng-content select="[caption-left]"></ng-content>
        <ng-template ngFor let-buttonConf [ngForOf]="headerButtonConfig" let-confIndex="index">
          <ng-container>
              <i *ngIf="buttonConf.separator" class="toolbar-separator fa fa-diamond"></i>
              <button *ngIf="!buttonConf.separator" pButton
                      type="button" [disabled]="!tableValueMap['bttHeaderEnabled-'+confIndex]"
                      (click)="buttonConf.items?tableMenu.toggle($event):buttonConf.command(selectedIds)"
                      [icon]="buttonConf.icon"
                      [class]="'p-button-text p-button-sm '+buttonConf.class"
                      [pTooltip]="buttonConf.tooltip"
                      [label]="buttonConf.label"></button>
              <p-menu #tableMenu [popup]="true" [id]="buttonConf.id" [model]="buttonConf.items"
                      [appendTo]="'body'"></p-menu>
          </ng-container>
        </ng-template>
      </span>
      <span class="caption-center">
        <ng-content select="[caption-center]"></ng-content>
      </span>
      <span class="caption-right">
        <span class="m-0-5"></span>
        <span class="p-input-icon-left p-ml-auto">
          <i class="pi pi-search"></i>
          <input pInputText
                 type="text"
                 class="p-inputtext-sm p-menu-search-input"
                 [(ngModel)]="globalFilterValue"
                 (input)="onGlobalFilterInput()"
                 placeholder="{{'common.table.filter_global' | translate}}">
          <!--          <input pInputText type="text" class="p-inputtext-sm p-menu-search-input" [(ngModel)]="globalFilterValue"-->
          <!--                 (input)="ccTable.filterGlobal(globalFilterValue, 'contains')"-->
          <!--                 placeholder="{{'common.table.filter_global' | translate}}"/>-->
        </span>
        <button pButton class="p-button-text p-button-sm header-button clear-filter-button" icon="pi pi-filter-slash"
                (click)="clearFilter()" pTooltip="{{'common.table.clear_filters' | translate}}"
                tooltipPosition="left"
                [disabled]="!tableValueMap['hasFilter']"></button>
        <button pButton class="p-button-text p-button-sm header-button clear-sort-button" icon="pi pi-sort-alt-slash"
                (click)="clearSort()" pTooltip="{{'common.table.clear_sort' | translate}}"
                [disabled]="!tableValueMap['hasSort']"></button>
        <ng-content select="[caption-right]"></ng-content>
      </span>
    </ng-template>

    <ng-template pTemplate="header">
      <tr class="h-20px">
        <th *ngFor="let columnDef of tableConfig" pReorderableColumn
            [pResizableColumn]="!columnDef.notResizable&&columnDef.type!='BUTTON'?columnDef.field:''"
            [pSortableColumn]="!columnDef.notSortable&&columnDef.type!='BUTTON'?columnDef.field:''"
            [style.min-width]="!columnDef.hidden && columnDef.width ? columnDef.width+'px' : null"
            [style.text-align]="!columnDef.hidden ? columnDef.align : null"
            [class.cc-col-hidden]="columnDef.hidden"
            [hidden]="columnDef.hidden">
          {{ columnDef.label ? columnDef.label : 'page.' + this.transPartKey + '.table.' + columnDef.field | translate }}
          <p-columnFilter *ngIf="!columnDef.notFilterable&&columnDef.filterConfig" #filterField
                          [type]="columnDef.filterConfig.type"
                          [field]="columnDef.field" display="menu" [matchMode]="columnDef.filterConfig.matchMode"
                          [showMatchModes]="complexFilterMode||columnDef.filterConfig.type==='date'"
                          [showOperator]="complexFilterMode"
                          [showAddButton]="complexFilterMode||columnDef.filterConfig.type==='date'"
                          [showApplyButton]="!columnDef.filterConfig.values" [showClearButton]="true"
                          [hideOnClear]="true"
                          [maxFractionDigits]="columnDef.filterConfig.type==='numeric'?5:undefined">
            <ng-template *ngIf="columnDef.filterConfig.values" pTemplate="filter" let-value let-filter="filterCallback">
              <p-dropdown *ngIf="columnDef.filterConfig.values&&columnDef.filterConfig.values.length===2"
                          [ngModel]="value" [options]="columnDef.filterConfig.values"
                          placeholder="Any" (onChange)="filter($event.value); filterField.hide();">
                <ng-template let-option pTemplate="item">
                  <span [class]="'option-' + option">{{ option }}</span>
                </ng-template>
              </p-dropdown>
              <p-multiSelect *ngIf="columnDef.filterConfig.values&&columnDef.filterConfig.values.length>2"
                             [ngModel]="value"
                             [options]="columnDef.filterConfig.values" placeholder="Any"
                             (onChange)="filter($event.value); filterField.hide();">
                <ng-template let-option pTemplate="item">
                  <div class="p-multiselect-option">
                    {{ option }}
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
          <p-sortIcon *ngIf="!columnDef.notSortable" [field]="columnDef.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-record let-rowIndex="rowIndex">
      <tr class="h-20px disable-text-selection {{record.selected?'p-highlight':''}} stripe_0"
          (mousedown)="onRowMouseDown(record[fieldId], rowIndex, $event)"
          (mouseup)="onRowMouseUp(record[fieldId], rowIndex, $event)"
          [pContextMenuRow]="record" [id]="recordIds[rowIndex]"
          (dblclick)="onRowDblClick_(record)"
          (focusin)="focuseIn(rowIndex)" (focusout)="focusOut()"
          (mouseenter)="focuseIn(rowIndex,true)" (mouseleave)="focusOut(true)">
        <td *ngFor="let columnDef of tableConfig"
            [style.min-width]="!columnDef.hidden && columnDef.width ? columnDef.width+'px' : null"
            [style.text-align]="!columnDef.hidden ? columnDef.align : null"
            [style.max-width]="!columnDef.hidden && columnDef.width ? columnDef.width+'px' : 'auto'"
            [style.width]="!columnDef.hidden && columnDef.width ? columnDef.width+'px' : 'auto'"
            [class.cc-col-hidden]="columnDef.hidden"
            [hidden]="columnDef.hidden"
            [class]="record[columnDef.field+'_class']"
            [ngStyle]="record[columnDef.field+'_style'] | styleStringToObj"
            [innerHTML]="(record[columnDef.field+'_icon']+record[columnDef.field+'_value']) | safeHtml"
            (click)="selectCell($event,columnDef, record[columnDef.field+'_value'])"
            [attr.title]="columnDef.showToolTip?record[columnDef.field+'_value']:null">
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="loadingbody" let-columns="columns">
      <tr class="loading-row stripe_0">
        <i class="pi pi-spin pi-spinner"></i>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <span class="footer-left">
        <button pButton icon="fa fa-file-excel" tooltipPosition="top"
                [class]="'p-button-text p-button-sm button-export'"
                (click)="exportRecords('xlsx')" pTooltip="{{'common.table.export_xls' | translate}}"></button>
        <button pButton icon="fa fa-file-csv" tooltipPosition="top"
                [class]="'p-button-text p-button-sm button-export'"
                (click)="exportRecords('csv')" pTooltip="{{'common.table.export_csv' | translate}}"></button>
        <ng-content select="[footer-left]"></ng-content>
      </span>
      <span class="footer-center">
        <ng-content select="[footer-center]"></ng-content>
      </span>
      <span class="footer-right">
        <ng-template ngFor let-buttonConf [ngForOf]="footerButtonConfig" let-confIndex="index">
          <span>
            <i *ngIf="buttonConf.separator" class="toolbar-separator fa fa-diamond"></i>
            <button *ngIf="!buttonConf.separator" pButton
                    type="button" [disabled]="!tableValueMap['bttFooterEnabled-'+confIndex]"
                    (click)="buttonConf.command(selectedIds)" [icon]="buttonConf.icon"
                    [class]="'p-button-text p-button-sm '+buttonConf.class"
                    [pTooltip]="buttonConf.tooltip"></button>
          </span>
        </ng-template>
        <ng-content select="[footer-right]"></ng-content>
      </span>
    </ng-template>
  </p-table>
</span>
